// extracted by mini-css-extract-plugin
export default {"commercialPlans":"CommercialPlans_commercialPlans__PH-Tr"};